import Image from "next/image";
import { useRouter } from "next/router";
import React from "react";
import Utils from "../../utils/Utils";

export const MatchupBreakdowns = ({ show = true }) => {
  const router = useRouter();
  return (
    <div className="container stats-explained">
      <div className="text-left">
        <h2>Matchup Breakdowns</h2>
        <h5>How exactly does the Matchup Breakdowns tool work?</h5>
      </div>
      <div className="text-left" style={{ display: "flex", flexDirection: "column" }}>
        <p>
          <b style={{ color: "#d07c3b" }}>Matchup Breakdowns</b> allow for custom matchup creation; assign any team to
          the home or away side, or use the Neutral checkbox for a tournament game. The generated result features the
          expected score and key SQ data for each team’s offensive and defensive abilities and frequencies, conveniently
          placed together for easy game analysis.
        </p>

        <Image
          src={Utils.getAsset("MatchupBreakdownPreview.png")}
          alt="picture showing how the matchup breakdown tool works"
          className="rounded"
        />

        <a
          href={`/matchup-tool`}
          target={"_blank"}
          style={{
            padding: "15px 50px",
            width: "200px",
            alignSelf: "center",
            marginTop: "15px",
          }}
          className="btn btn-orange"
        >
          Go to the Tool
        </a>
      </div>
    </div>
  );
};
